import sleep from '../helpers/sleep';

export const DEFAULT_FIELD_MAX_LENGTH = 512;

type Json = string | number | boolean | null | JsonObject | JsonArray;
type JsonArray = Array<Json>;
interface JsonObject {
  [property: string]: Json | unknown;
  [property: number]: Json | unknown;
}
export interface Precondition {
  condition: string;
  errorGoto: string;
}
export interface Field {
  fieldId: string;
  value: number | string | boolean;
  label: string;
  placeHolder: string;
  mobilePlaceHolder?: string;
  type:
    | 'text'
    | 'number'
    | 'decimal'
    | 'amount'
    | 'email'
    | 'info'
    | 'integer'
    | 'boolean'
    | 'address'
    | 'date'
    | 'file'
    | 'list'
    | 'string'
    | 'strings'
    | 'ssn'
    | 'phone';
  prettyValue: string;
  displayValue: string | null;
  imgDefault?: string;
  imgChecked?: string;
  icon?: string;
  optional?: boolean;
  maxLength?: number;
  minLength?: number;
  min?: number;
  max?: number;
  inputmode?: string;
  autocomplete?: string | 'off';
  suggestions?: string[];
  pattern?: string;
  disabled?: boolean;
  required?: boolean;
  name?: string;
  list?: string;
  spellcheck?: boolean;
}

export interface HintField {
  fieldId: string;
  imgDefault: string | null;
  label: string;
  placeHolder: string | null;
  secure: boolean;
  type: string;
  value: boolean | string | number;
}

export interface Next {
  soap: 'soap';
  isReadOnly: boolean;
  hasNewFlowId: boolean;
  hasNewNodeId: boolean;
  nextFlowId: null | string;
  nodeId: null | string;
}
export interface CoafFlowNodePrecondition {
  condition: string;
  errorGoto: string;
}

export interface Node {
  nodeId: string;
  contentId: string;
  from: string | undefined;
  froms: Record<string, unknown>;
  next: Next[];
  preconditions: CoafFlowNodePrecondition[];
}

export type CoafNodeComponentType =
  | 'image'
  | 'checkboxNoImage'
  | 'checkboxImage'
  | 'radioNoImage'
  | 'radioImage'
  | 'multipleText'
  | 'checklist'
  | 'text'
  | 'email'
  | 'number'
  | 'textArea'
  | 'consent'
  | 'hintHeader'
  | 'hint'
  | 'valueInput'
  | 'file'
  | 'input_text'
  | 'nemidSsn'
  | 'range'
  | 'range- | '
  | 'slider'
  | 'iframe'
  | 'address'
  | 'nemid'
  | 'flowOverview'
  | 'pensionsinfo'
  | 'redirect'
  | 'skipPage'
  | 'submit'
  | 'flow-end'
  | 'popup';

export interface DevFlow extends PopulatedFlow {
  favoriteIcon?: null | string;
  flowType?: string;
  sideBarDescription?: null | string;
  title?: string;
}

export interface SliderLabels extends Slider {
  displayLabelTitles: string[];
  displayLabels: string[];
  valueLabels: string[];
}

export interface Slider {
  sliderMin: string | number;
  sliderMax: string | number;
}

export interface PopupComponent {
  closeBtnIsVisible: boolean;
  closeOnClickOutside: boolean;
  specificWidth: string;
  textContent: string | null;
  popupButtonLabel: string | null;
  popupButtonSlot: string | null;
  flowsCompletedDialog?: boolean;
}

export interface ComponentOptions {
  popupId?: string;
  popupLink?: string;
  optional?: boolean;
  image?: string;
  popupTitle?: string;
  popupText?: string;
  popupImage?: string;
  showCloseIcon?: boolean;
  buttonLabel?: string;
  backButtonUrl?: string;
}

export interface PopupProperties {
  width: string | null;
  modal: boolean | null;
  header: {
    preImage: string | null;
    preImageUrl: string | null;
    text: string | null;
    postImage: string | null;
    postImageUrl: string | null;
  };
  body: {
    text: string | null;
    url: string | null;
  };
  buttons: {
    close: {
      showCloseIcon: boolean | null;
      label: string | null;
    };
    action: {
      label: string | null;
    };
  };
}

export interface ComponentProperty {
  componentId: string;
  type: CoafNodeComponentType;
  options: ComponentOptions | PopupComponent | Slider | SliderLabels;
  fields: Field[];
  values: Value[];
  isSingleFieldValue: boolean;
}

type CoafNodeType = 'question' | 'custom-component' | 'providers' | 'flow-end';

export interface Value {
  componentId: string;
  fieldId: string;
  value: any;
  checked?: boolean;
  displayValue?: string;
}
export interface Content extends JsonObject {
  nodeId: string;
  nodeType: CoafNodeType;
  titles: string[];
  name: string;
  components: ComponentProperty[];
}

export interface Flow {
  startNodeId: string;
  nodes: Node[];
}
export interface Database {
  flows: Record<string, Flow>;
  nodes: Record<string, Content>;
  submissions: Record<string, unknown>[];
}

export interface PopulatedFlow {
  name: string;
  startNodeId: string;
  nodes: Array<NodePage>;
  options: CoafFlowNodeOptions;
}

export interface CoafFlowNodeOptions {
  showBackButton: boolean;
  backButtonUrl: string | null;
}

export interface TableResponse {
  index: number;
  key: string;
  pensionProviderTypeName: string;
  pensionProviderTypeNumber: number;
  referenceNumber: string;
  subscriptionType: string;
  payment: string;
  paymentDate: string;
  savedValueDate: string;
  savings: string;
  pensionType: string;
  pensionMovablility: number;
  pensionMovablilityReasonsText: string[] | null;
  isPensionMovable: boolean;
  toggle: {
    id: string;
    value: boolean;
  };
  pensionNotMovableText: string | null;
  pensionMaybeMovableText: string | null;
  eventTime: string;
  investmentValue: null | string;
  investmentValueDate: null | string;
  pensionMovablilityReasons: string[];
  imgIsValid?: boolean;
  isNotMovableToggled?: boolean;
}

export type NodePage = Node & Content;

export class MockAPI {
  coafJson = require('./coaf.json');

  async get(path: string): Promise<unknown> {
    sleep(2);
    return { data: this.coafJson };
  }

  post(): boolean {
    sleep(2);
    return true;
  }
}
